import axios from "axios";
import {azureFrontUrl, apiAzureUrl, apiLocalHttp, frontLocalHttp} from '@/uptk/core/api/contants'
import {getActiveConfig} from "../../../authConfig";
export const SEARCH_TIMEOUT = 2500000; // TODO: Set back to 25000 and debug the management of error message

export const isLocalhost = (): boolean => {

    let isLocal: boolean | RegExpMatchArray | null = false;

    if (!getActiveConfig().auth.checkIslocalHost) {
        return Boolean(isLocal);
    } else {
        // [::1] is the IPv6 localhost address.
        // 127.0.0.1/8 is considered localhost for IPv4.
        isLocal = window.location.hostname == 'localhost' ||
            window.location.hostname == '[::1]' ||
            window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/);
        return Boolean(isLocal)
    }
};

// var Window;

class Rest {

    static getFrontUrl(url: any) {
        return isLocalhost() ? `${frontLocalHttp}${url}` : `${azureFrontUrl()}${url}`
    }

    static getUrl(url: any) {
        // In development with Vite, use relative URLs to go through proxy
        return isLocalhost() ? url : `${apiAzureUrl()}${url}`
    }

    static getBackendUrl(url: any) {
        return isLocalhost() ? `${apiLocalHttp}/api${url}` : `${apiAzureUrl()}/api${url}`
    }

    static handleFetchError(error: any, dispatch: any, callbackForFailure: any) {
        console.warn("Failed to fetch data from test services.", error);
        if (callbackForFailure) callbackForFailure(error);
    }

    static getHeaders(accessToken: any) {

        // TODO true is not working, to debug actually false is working but not secure
        const maskHeader = false; // False is used to debug

        let bearer = `Bearer ${accessToken}`;
        let headers: any;
        let headerConfig = {};

        if (accessToken != undefined) {
            headerConfig = Object.assign({}, {...headerConfig, 'Authorization': bearer})
        }
        if (isLocalhost()) {

            // console.debug("Cross Origin set to : " + frontLocalHttp )
            headerConfig = Object.assign({}, {
                ...headerConfig,
                'Access-Control-Allow-Origin': frontLocalHttp
            })
        } else {
            // console.debug("Cross Origin set to : " + azureFrontUrl())
            headerConfig = Object.assign({}, {
                ...headerConfig,
                'Access-Control-Allow-Origin': azureFrontUrl()
            })
        }
        headerConfig = Object.assign({}, {
            ...headerConfig,
            'Access-Control-Allow-Methods': 'GET, HEAD, POST, PUT, DELETE, TRACE, OPTIONS, PATCH'
        })

        headerConfig = Object.assign({}, {
            ...headerConfig,
            'Access-Control-Allow-Headers': 'Range'
        })
        headerConfig = Object.assign({}, {
            ...headerConfig,
            'Access-Control-Expose-Headers': 'Accept-Ranges, Content-Encoding, Content-Length, Content-Range'
        })
        headerConfig = Object.assign({}, {
            ...headerConfig,
            'Content-Type': 'application/json',
        })

        if (maskHeader) {
            headers = new Headers(headerConfig as any);
            if (isLocalhost()) {
                console.debug("header Authorization                 : " + headers.get("Authorization"));
                console.debug("header Access-Control-Allow-Origin   : " + headers.get("Access-Control-Allow-Origin"));
                console.debug("header Access-Control-Allow-Headers  : " + headers.get("Access-Control-Allow-Headers"));
                console.debug("header Access-Control-Expose-Headers : " + headers.get("Access-Control-Expose-Headers"));
                console.debug("header Content-Type                  : " + headers.get("Content-Type"));
            }
        } else {
            headers = {headers: headerConfig};
        }
        return headers;
    }


    static getHttpOptions(args: any) {
        const method = args.method || 'GET';
        const data = (method != 'GET') ? args.body : undefined;

        let httpArgs= {
            method,
            // axios expects `data` for request body
            data
        } as any;

        if (httpArgs.method != 'GET' && args.body !== undefined) {
            httpArgs.data = args.body;
        }

        return httpArgs;
    }

    static executeRestCall(args: any, dispatch: any, cbSuccess?: any, cbFail?: any, retryCounter: number = 0) {

        let fetchArgs = Rest.getHttpOptions(args)

        let timedOut = false;

        return new Promise((resolve, reject) => {

            const timeout = setTimeout(() => {
                timedOut = true;
                reject(new Error('Request Timed Out!'));
            }, SEARCH_TIMEOUT);

            axios(args.url, fetchArgs)
                .then((response) => {
                    clearTimeout(timeout);
                    if (response.status >= 400 || response.status == 204) {
                        if (response.status == 405 && retryCounter < 1) {
                            retryCounter++;
                            // retry
                            return this.executeRestCall(args, dispatch, cbSuccess, cbFail, retryCounter).then(resolve).catch(reject);
                        } else {
                            const bodyForError = (!args?.doNotLogArgs && args?.body) ? args.body : null;
                            throw new Error(`${response.status} ${fetchArgs.method} ${args.url} ${bodyForError}`);
                        }
                    } else {
                        const payload = response.data;
                        if (cbSuccess) cbSuccess(payload);
                        resolve(payload);
                    }
                })
                .catch((err) => {
                    // TODO DEBUG to avoid the generation of a naughty error message on the screen, actually the timeout has been pushed to a big limit to avoid the error
                    if (timedOut) {
                        return;
                    }
                    Rest.handleFetchError(err, dispatch, cbFail);
                    reject(err)
                });
        });
    }
}

export default Rest;

